export default "__VITE_ASSET__dab71a07__"